const getEnvVariable = ev => {
    if (!process.env[ev] && window.env[ev] === `{{${ev}}}`) {
        throw new Error(`Please add ${ev} to .env file or pass it into container properly`);
    }

    return process.env[ev] || window.env[ev];
};

export default getEnvVariable;
